export enum StorageForecastingAddOns {
    QuarterlyPowerCurves = 'QuarterlyPowerCurves',
    BessForecasting = 'BessForecasting',
    CapacityMarket = 'CapacityMarket',
    TNUoS = 'TNUoS',
    TLMs = 'TLMs',
    WindForecasting = 'WindForecasting',
    SolarForecasting = 'SolarForecasting',
}
